import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// main.js文件

// element - ui
import ElementUI from 'element-ui';
import i18n from '@/utils/vueIN.js'
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

import 'element-ui/lib/theme-chalk/index.css';

// en 是英文 zh-CN是中文
// import locale from 'element-ui/lib/locale/lang/zh-CN' 
// import locale from 'element-ui/lib/locale/lang/en'
// Vue.use(ElementUI, { locale })

// import 'babel-polyfill'
Vue.config.productionTip = false
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
import VueParticles from 'vue-particles'//vue中使用动画vue-particles实现背景粒子酷炫效果
Vue.use(VueParticles)
import AvueMap from 'avue-plugin-map'//导入地图插件
Vue.use(AvueMap)
import less from 'less'
Vue.use(less)



//图片放大缩小
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true, // 启用 inline 模式
    'button': true, // 显示右上角关闭按钮
    'navbar': true, // 显示缩略图导航
    'title': true, // 显示当前图片的标题
    'toolbar': true, // 显示工具栏
    'tooltip': true, // 显示缩放百分比
    'movable': true, // 图片是否可移动
    'zoomable': true, // 图片是否可缩放
    'rotatable': true, // 图片是否可旋转
    'scalable': true, // 图片是否可翻转
    'transition': true, // 使用 CSS3 过度
    'fullscreen': true, // 播放时是否全屏
    'keyboard': true, // 是否支持键盘
    'url': 'data-source' // 设置大图片的 url
  }
})


new Vue({
  router,
  store,
  i18n,// 挂载
  render: h => h(App)
}).$mount('#app')
